export default "__VITE_ASSET__55a48ac2__"